import React from "react"

import { Button, Popover, OverlayTrigger } from "react-bootstrap"

import { isLTPM } from "../../../../components/shared_components_registration"

const registration = {
  title: (intl) =>
    isLTPM
      ? intl.formatMessage({ id: "graphing.edit.size", defaultMessage: "Edit Graph Dimensions" })
      : "Edit Graph Dimensions",
  label: (intl) => (isLTPM ? intl.formatMessage({ id: "general.width", defaultMessage: "Width" }) : "Width"),
  axisLabel: (intl) =>
    isLTPM ? intl.formatMessage({ id: "general.height", defaultMessage: "Height" }) : "Height",
  resetFontSize: (intl) =>
    isLTPM ? intl.formatMessage({ id: "general.reset", defaultMessage: "Reset" }) : "Reset",
}

const GraphSizeEditPopover = ({ defaultDim, dim, setDim, intl }) => {
  const graphSizeEditPopoverStyle = {
    popoverContentDivRow: { margin: "10px" },
    popoverContentDivCol: { marginTop: "5px" },
    PopoverContentInput: { marginLeft: "5px", width: "100px" },
  }

  const overlay = (
    <Popover id="graphSizeEdit" title={registration["title"](intl)}>
      <Popover.Header as="h3">{registration["title"](intl)}</Popover.Header>
      <Popover.Body>
        <div style={graphSizeEditPopoverStyle.popoverContentDivRow}>
          <div>
            <label>{registration["label"](intl)}</label>:
            <input
              style={graphSizeEditPopoverStyle.PopoverContentInput}
              type="number"
              min="1"
              step="1"
              value={dim.width}
              placeholder={defaultDim.width}
              onWheel={(e) => e.target.blur()}
              onChange={(e) => {
                const newWidth = parseInt(e.target.value)
                setDim({
                  width: !newWidth || newWidth <= 0 ? 1 : newWidth,
                  height: dim.height,
                })
              }}
            />
          </div>
          <div style={graphSizeEditPopoverStyle.popoverContentDivCol}>
            <label>{registration["axisLabel"](intl)}</label>:
            <input
              style={graphSizeEditPopoverStyle.PopoverContentInput}
              type="number"
              min="1"
              step="1"
              value={dim.height}
              placeholder={defaultDim.height}
              onWheel={(e) => e.target.blur()}
              onChange={(e) => {
                const newHeight = parseInt(e.target.value)
                setDim({
                  height: !newHeight || newHeight <= 0 ? 1 : newHeight,
                  width: dim.width,
                })
              }}
            />
          </div>
          <div style={graphSizeEditPopoverStyle.popoverContentDivCol}>
            <Button
              title={registration["resetFontSize"](intl)}
              variant={"outline-primary"}
              size="sm"
              onClick={() => setDim(defaultDim)}
            >
              {registration["resetFontSize"](intl)}
            </Button>
          </div>
        </div>
      </Popover.Body>
    </Popover>
  )

  return (
    <OverlayTrigger trigger={"click"} placement="left" rootClose overlay={overlay}>
      <Button title={registration["title"](intl)} variant={"outline-primary"}>
        <span className="fa fa-solid fa-area-chart" />
        <span className="fa fa-solid fa-crop" />
      </Button>
    </OverlayTrigger>
  )
}

export default GraphSizeEditPopover
